/**
 * SPM A 位站点段（品牌×站点）。
 *
 * 多站点项目不在代码里写死 zeelool_us：站点标识读取 env.NEXT_PUBLIC_SITE_NAME
 * （us/de/ca/fr/uk，各站点 env 均已声明），推导为 `zeelool_${site}`。
 * 配置缺失时（本地脚本、单测环境）回退 us，保证行为确定。
 */
import { env } from '@/utils/env';

export function getSpmSitePrefix(): string {
  return `zeelool_${env.NEXT_PUBLIC_SITE_NAME ?? 'us'}`;
}
